// --- ReferenceSelector.tsx ---
import React from "react";
import { SpatialData } from "../../domain/types";

interface ReferenceSelectorProps {
  onSelect: (ref: SpatialData["referenceObject"]) => void;
}

export const ReferenceSelector: React.FC<ReferenceSelectorProps> = ({ onSelect }) => {
  const options: Array<{ value: SpatialData["referenceObject"]; label: string; dims: string }> = [
    { value: "DOOR_90x200", label: "Ościeżnica drzwiowa", dims: "90×200cm" },
    { value: "SOCKET_60MM", label: "Puszka elektryczna", dims: "60×60mm" },
    { value: "CUSTOM", label: "Inny element", dims: "Wymagana kalibracja" }
  ];

  return (
    <div className="space-y-3">
      <div className="text-white text-sm font-mono uppercase mb-4">
        Wybierz punkt odniesienia do skalowania:
      </div>
      
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onSelect(opt.value)}
          className="w-full min-h-[60px] bg-[#1a1a1a] border border-[#333] 
                   text-left px-4 hover:border-[#00e676]
                   focus:ring-2 focus:ring-[#00e676] focus:outline-none
                   rounded-[16px] transition-colors"
        >
          <div className="text-white font-bold text-sm">{opt.label}</div>
          <div className="text-[#666] text-xs font-mono">{opt.dims}</div>
        </button>
      ))}
    </div>
  );
};
